<template>
    <b-modal
        class="base-modal"
        :class="name"
        :modal-class="`${ name }-modal`"
        :id="name"
        :hide-header="hideHeader"
        :hide-footer="hideFooter"
        centered
        :title="title"
        :aria-label="title"
        v-bind="$attrs"
    >
        <template #modal-header="{ close }">
            <h5 class="modal-title" v-test:modalTitle>{{ title }}</h5>
            <b-button
                class="close-btn"
                size="sm"
                variant="link"
                @click="close"
                v-test:closeBtn
            >
                <app-icon name="close" :title="$snippet('close_modal', 'Close modal.')" />
            </b-button>
        </template>

        <template #default>
            <div v-test:defaultSlot class="content">
                <slot />
            </div>
        </template>
    </b-modal>
</template>

<script>
    import { ModalPlugin } from 'bootstrap-vue';
    import Vue from 'vue';

    Vue.use(ModalPlugin);

    export default {
        name: 'base-modal',

        props: {
            name: {
                type: String,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            hideHeader: {
                type: Boolean,
                default: false,
            },

            hideFooter: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss">
    @import "~bootstrap/scss/modal";
</style>

<style lang="scss" scoped>
    ::v-deep {
        @import '~bootstrap-vue/src/components/modal/_modal.scss';

        .modal-header {
            padding: $modal-header-padding-y $modal-inner-padding 0;
        }

        .close-btn {
            min-width: unset;
            padding: 0;
            width: 35px;
            height: 35px;
        }

        .modal-footer {
            padding: 0 $modal-inner-padding $modal-header-padding-y $modal-inner-padding;
        }
    }
</style>
